<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Planilla de Despacho</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> N° de Orden de Compra: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Fecha de Orden de Compra: {{ fecha }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="8" md="10">
                                    <v-textarea dense v-model="descr" rows="2" auto-grow readonly outlined
                                        color="black"></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense v-model="cantidad" label="Cantidad de Entregas" outlined
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listado" :single-expand="false"
                                locale="es-ar" class="elevation-1" show-expand :items-per-page="200" hide-default-footer
                                :expanded.sync="expanded" item-key="index">
                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" margin="2px">
                                        Detalle Bultos
                                        <v-textarea dense v-model="item.detallebultos" outlined rows="12" color="black"
                                            class="font-class-name"></v-textarea>
                                    </td>
                                </template>
                                <template v-slot:item.item="{ item }">
                                    <v-text-field dense v-model="item.item" outlined color="black"
                                        class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.camion="{ item }">
                                    <v-text-field dense v-model="item.camion" outlined color="black"
                                        class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.bultos="{ item }">
                                    <v-text-field dense v-model="item.bultos" outlined color="black"
                                        class="font-class-name"></v-text-field>
                                </template>
                                <template v-slot:item.estado="{ item }">
                                    <v-select dense v-model="item.estado" :items="estados" item-text="nombre"
                                        item-value="valor" outlined class="font-class-name" color="black"></v-select>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="#f2d7d5">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select color="red darken-3" dense v-model="estado" :items="listadoestado"
                                        label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="4" md="4">
                                    <v-text-field color="red darken-3" required label="Enviar mail a:" dense
                                        v-model="direccion"></v-text-field>
                                </v-col>
                                <v-col cols="4" sm="1" md="1">
                                    <v-btn class="mx-2" @click="botonMail" dark small color="orange">
                                        <v-icon dark>
                                            mdi-arrow-left-bold
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-combobox color="red darken-3" dense v-model="correos" :items="direcciones"
                                        label="Listado mails" item-text="nombre" item-value="mail"></v-combobox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name {
    font-size: 14px;
}
</style>
<style lang="scss">
.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}

.v-textarea textarea {
    line-height: 1rem !important;
    margin: 1px;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data() {
        return {
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            descr: "",
            fecha: "",
            cantidad: "",
            tipo: "",
            listado: [{ id: "0", entrega: "1", item: "", camion: "", bultos: "", estado: "", detallebultos: "" },
            ],
            listadodespacho: [],
            estado: "",
            listadoestado: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'En Despacho', valor: 'E' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            headers: [
                { text: "Entrega", value: "entrega", sortable: false, width: "5%" },
                { text: "Item", value: "item", sortable: false },
                { text: "Tipo y Cantidad de Camiones", value: "camion", sortable: false, width: "25%" },
                { text: "Total de Bultos", value: "bultos", sortable: false, width: "7%" },
                { text: "Estado", value: "estado", sortable: false, width: "15%" },

            ],
            deshabilitar: false,
            expanded: [],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
        };
    },

    props: ["visible", "codgral", "codoc"],
    computed: {
        // deshabilitar() {
        //     if (this.estado !== "C") return false;

        //     return this.listado.some(item => {
        //         const estadoItem = (item.estado || "").trim().toUpperCase();
        //         console.log("Estado del item:", estadoItem);
        //         return estadoItem === "P";
        //     });
        // },
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListadoMail();
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    //this.$refs.form.resetValidation();
                    //document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    },
    // created() {
    //     this.setExpanded(); // Inicializa el estado expanded
    // },
    watch: {
        cantidad() {
            this.actualizarDeshabilitar();
        },
        estado() {
            this.actualizarDeshabilitar();
        },
        listado: {
            handler() {
                this.actualizarDeshabilitar();
            },
            deep: true
        }
    },
    methods: {
        actualizarDeshabilitar() {
            const estadoPrincipal = (this.estado || "").trim().toUpperCase();
            const cantidadNumerica = Number(this.cantidad);
            const cantidadVacia = this.cantidad === "" || this.cantidad === null;

            const tieneEntregaPendiente = this.listado.some(item => {
                const estadoItem = (item.estado || "").trim().toUpperCase();
                return estadoItem === "P";
            });

            const cantidadMayorQueListado = cantidadNumerica > this.listado.length;

            // Solo deshabilitar el botón, sin mostrar alertas reactivamente
            if ((cantidadVacia && estadoPrincipal === "C") ||
                (estadoPrincipal === "C" && tieneEntregaPendiente) ||
                (estadoPrincipal === "C" && cantidadMayorQueListado)) {
                this.deshabilitar = true;
            } else {
                this.deshabilitar = false;
            }
        },

        validarAntesDeGuardar() {
            const mensajes = [];

            const estadoPrincipal = (this.estado || "").trim().toUpperCase();
            const cantidadNumerica = Number(this.cantidad);
            const cantidadVacia = this.cantidad === "" || this.cantidad === null;

            const tieneEntregaPendiente = this.listado.some(item => {
                const estadoItem = (item.estado || "").trim().toUpperCase();
                return estadoItem === "P";
            });

            const cantidadMayorQueListado = cantidadNumerica > this.listado.length;

            if (cantidadVacia && estadoPrincipal === "C") {
                mensajes.push("La cantidad no puede estar vacía si el estado es 'Cerrado'.");
            }

            if (estadoPrincipal === "C" && tieneEntregaPendiente) {
                mensajes.push("No puede Cerrar si alguna entrega no está en estado 'Cerrado'.");
            }

            if (estadoPrincipal === "C" && cantidadMayorQueListado) {
                mensajes.push("No puede Cerrar si la cantidad es mayor al número de entregas realizadas hasta el momento.");
            }

            return mensajes;
        },


        cargarListadoMail() {
            let self = this;
            axios
                .get("/Icssa/GetMail?")
                .then((response) => {
                    self.direcciones = response.data;
                })
                .catch((error) => {
                    self.direcciones = [];
                    console.log(error);
                });
        },
        botonMail() {
            this.direccion = this.direccion + this.correos.mail + ";";
        },
        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarDespacho?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.provision = response.data.provision;
                    self.fecha = response.data.fecha;
                    self.estado = response.data.estado;
                    self.cantidad = response.data.cantidad;
                    self.tipo = response.data.tipo;
                    self.descr = response.data.descr;
                    self.listado = response.data.despacho;

                    const entrega = self.listado.length + 1;
                    //if (self.listado.length == 0) {
                    self.listado.push({ id: "0", entrega: entrega, item: "", camion: "", bultos: "", estado: "", detallebultos: "" },)
                    //}
                    self.expanded = [0, 1, 2, 3, 4, 5, 6]
                    //self.setExpanded();
                }
                )
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        guardar() {
            // Validar antes de proceder
            const errores = this.validarAntesDeGuardar();
            if (errores.length > 0) {
                this.$swal.fire({
                    icon: "warning",
                    title: "No se puede guardar",
                    html: errores.map(e => `<p>${e}</p>`).join(""),
                    showConfirmButton: true,
                    background: "#ececec",
                });
                return;
            }

            this.$swal({
                title: "Guardar Despacho",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.listadodespacho = [];
                    this.listado.forEach((element) => {
                        if ((element.detallebultos != "" && element.detallebultos != null) || (element.item != "" && element.item != null)) {
                            this.listadodespacho.push({
                                codgral: this.codgral,
                                codoc: this.codoc,
                                item: element.item,
                                entrega: element.entrega,
                                camion: element.camion,
                                bultos: element.bultos,
                                detallebultos: element.detallebultos,
                                estado: element.estado,
                            });
                        }
                    });
                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        empresa: this.empresa,
                        tipo: this.tipo,
                        cantidad: this.cantidad,
                        estado: this.estado,
                        mail: this.direccion,
                        despacho: this.listadodespacho,
                    };

                    let self = this;
                    axios
                        .post("/Lanzamiento/GuardarDespacho", datos)
                        .then((response) => {
                            var data = response.data || {};
                            if (data.mailEnviado === false) {
                                self.$swal.fire({
                                    icon: "warning",
                                    title: "Planilla guardada",
                                    text:
                                        data.mensaje ||
                                        "El despacho se registró correctamente, pero no se pudo enviar el mail de aviso.",
                                    background: "#ececec",
                                    confirmButtonText: "Entendido",
                                });
                            } else {
                                self.showAlert({
                                    icon: "success",
                                    title: "Planilla guardada con éxito",
                                    vm: self,
                                });
                            }
                            self.vaciarListado();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            self.deshabilitar = false;
                            self.showAlert({
                                icon: "error",
                                title: "Error al guardar la planilla",
                                vm: self,
                            });
                        });
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.fecha = "";
            this.provision = "";
            this.descr = "";
            this.tipo = "";
            this.cantidad = "";
            this.listado = [];
            this.listadodespacho = [];
            this.estado = "";
            this.direccion = "";
            this.correos = "";
            this.direcciones = [];
            this.deshabilitar = false;
        },
    },
};
</script>
